var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oa-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: "13%",
            visible: _vm.show,
            width: "500px",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "header", attrs: { slot: "title" }, slot: "title" },
            [
              _c("span", { staticClass: "title" }, [_vm._v("应用管理")]),
              _vm._v(" "),
              _c("span", {
                staticClass: "el-icon-close",
                on: { click: _vm.handleClose },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "scrollTarget",
              staticClass: "content mt20",
              class: _vm.fromItem.length > 7 ? "box-shadow" : "",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "draggable",
                    {
                      attrs: {
                        "chosen-class": "chosen",
                        "force-fallback": "true",
                        group: "people",
                        animation: "1000",
                      },
                      on: { start: _vm.onStart, end: _vm.onEnd },
                      model: {
                        value: _vm.fromItem,
                        callback: function ($$v) {
                          _vm.fromItem = $$v
                        },
                        expression: "fromItem",
                      },
                    },
                    [
                      _c(
                        "transition-group",
                        _vm._l(_vm.fromItem, function (item, index) {
                          return _c("div", { key: index }, [
                            _c(
                              "div",
                              { staticClass: "flex-between mb14" },
                              [
                                _c("i", {
                                  staticClass:
                                    "icon iconfont icontuodong item-drag",
                                }),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    clearables: "",
                                    "show-word-limit": "",
                                    placeholder: "请输入应用名称",
                                  },
                                  model: {
                                    value: item.name,
                                    callback: function ($$v) {
                                      _vm.$set(item, "name", $$v)
                                    },
                                    expression: "item.name",
                                  },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-remove item-remove",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(item, index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "add-type",
                  attrs: { size: "small", type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.handleAddType()
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-plus" }), _vm._v(" 添加应用")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-footer" },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取 消"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }